import React from 'react';
import {
  KeyboardDatePickerProps,
  KeyboardDatePicker,
  DatePicker,
  DateTimePicker,
  KeyboardDateTimePicker
} from '@material-ui/pickers';
import { isoDateToLocalDate } from '../../utils';
import { useDateTimeFormat } from '../../hooks';

export type DatePickerAdapterProps = Omit<KeyboardDatePickerProps, 'format'> & {
  keyboard?: boolean;
  dateTime?: boolean;
};

export const DatePickerAdapter = (props: DatePickerAdapterProps) => {
  const { keyboard = true, clearable, dateTime, value, ...rest } = props;
  const useClearable = props.variant === 'inline' ? undefined : clearable;

  const { dateTimeFormat } = useDateTimeFormat();

  const prop: KeyboardDatePickerProps & { 'data-test-id': string; 'data-component-role': 'date-picker' } = {
    'data-test-id': 'date-picker',
    'data-component-role': 'date-picker',
    clearable: useClearable,
    ...rest,
    // DatePicker operates on time zoned Date Object,
    // so we need to make sure that isoDateToLocalDate won't change selected Date as it expects Date Object created for UTC+0 timezone
    value: dateTime || isTimezonedDateObject(value) ? value : isoDateToLocalDate(value as string),
    format: dateTime ? `${dateTimeFormat.short} ${dateTimeFormat.time}` : dateTimeFormat.short
  };
  if (dateTime) {
    return keyboard ? <KeyboardDateTimePicker {...prop} /> : <DateTimePicker {...prop} />;
  }
  return keyboard ? <KeyboardDatePicker {...prop} /> : <DatePicker {...prop} />;
};

function isTimezonedDateObject(date: DatePickerAdapterProps['value']): boolean {
  if (!(date instanceof Date)) {
    return false;
  }
  return date.getDate() !== isoDateToLocalDate(date)?.getDate();
}
